import React, { useState } from "react";
import Image from "next/image";

const MobBridgeTable = () => {
  const [openAccordion, setOpenAccordion] = useState(1);

  const toggleAccordion = (index: any) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };
  return (
    <div className="mx-auto w-full px-5 relative bg-center bg-[#061A2F] bg-repeat md:bg-cover bg-[length:100% 100%] pt-[30px] pb-[40px] relative">
      <Image
        priority
        src="/images/business/soba/job_main_bg.png"
        alt="background"
        className="mx-auto absolute bottom-0 left-0 w-full"
        width={360}
        height={359}
      />

      <div className="mx-auto text-[#030F1C] z-10 relative">
        <h2 className="font-bold leading-[23px] text-[12px] text-white text-center mb-6">
          Miles Approved Bridge Programs
          <span className="border-[#ca7216] border-b-2 text-[20px] pb-[5px] inline-block relative">
            for Pre-education Eligibility
            <br /> for the CPA Exam
          </span>
        </h2>

        <div
          className="accordion-container pt-[30px] md:hidden block"
          defaultValue={1}
        >
          {/* Section1 */}
          <div className="accordion-item pb-[20px]">
            <div
              className="accordion-header rounded-[14px] ed_program_sha text-white p-4 border-[1px] border-[#3174d6]"
              onClick={() => toggleAccordion(1)}
            >
              <Image
                priority
                src="/images/business/soba/cap.png"
                alt="CFO-readiness"
                className=""
                width={32}
                height={32}
              />
              <h3 className="text-[16px] font-bold leading-[1.3] mt-2">
                M.com - Professional accounting & finance
                <span
                  className={`float-end text-white ${
                    openAccordion === 1 ? "Active" : "Not-Active"
                  }`}
                ></span>
                {openAccordion === 1 && (
                  <ul className="text-[14px] font-regular mt-2 list-disc list-inside">
                    <li>60 credits</li>
                    <li>Timeline: 2 year program</li>
                    <li>Fees: 45,500/-</li>
                    <li>No cost EMI available</li>
                    <li>100% CPA Integrated curriculum</li>
                  </ul>
                )}
              </h3>
            </div>
            {openAccordion === 1 && (
              <div className="accordion-content mt-[4px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)] rounded-b-[14px]">
                <div className="rounded-[18px] bg-[#fff]">
                  <div className="flex justify-between items-center">
                    <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                      <div className="overflow-hidden">
                        <table className="w-full">
                          <thead>
                            <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                              <th className="w-[6%] border-[1px] border-[#1D5287] py-[28px]"></th>
                              <th className="w-[28%] border-[1px] border-[#1D5287]">
                                <span>Courses</span>
                              </th>
                              <th className="w-[20%] border-[1px] border-[#1D5287]">
                                <span>CPA Integration</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#FFF]">
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black block font-semibold list-disc list-inside">
                                  Sem 1
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Financial Accounting & Reporting</li>
                                  <li>Technical Accounting & Reporting - I</li>
                                  <li>Management Accounting - I</li>
                                  <li>Business Finance - I</li>
                                  <li>Business Economics - I</li>
                                </ul>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-2 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 1</li>
                                  <li>FAR 3</li>
                                  <li>FAR 2 & 6.2</li>
                                  <li>FAR 4</li>
                                  <li>BAR 4.3</li>
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[11px] text-black font-semibold list-disc list-inside block">
                                  Sem 2
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Business Finance - II</li>
                                  <li>
                                    Not-for-Profit & Governmental Accounting
                                  </li>
                                  <li>Auditing & Attestation - I</li>
                                  <li>Business Economics - II</li>
                                  <li>Business Law - I</li>
                                  <li>Federal Income Taxation - I</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 5 & 6.1</li>
                                  <li>FAR 6.5 & 7</li>
                                  <li>AUD 1, 2, 3</li>
                                  <li>BAR 4.4, BAR 4.5</li>
                                  <li>REG 7.1, 7.2</li>
                                  <li>REG 1</li>
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[11px] text-black font-semibold list-disc list-inside block">
                                  Sem 3
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Management Accounting - II</li>
                                  <li>Technical Accounting & Reporting - II</li>
                                  <li>Auditing & Attestation - II</li>
                                  <li>Federal Income Taxation - II</li>
                                  <li>Financial Decision Making</li>
                                  <li>Business Communication & Ethics</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>BAR-2</li>
                                  <li>BAR-5</li>
                                  <li>AUD 4, 5</li>
                                  <li>REG 2 & 3</li>
                                  <li>BAR-1, 4.1, 4.2</li>
                                  <li>(Elective)</li>
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[11px] text-black font-semibold list-disc list-inside block">
                                  Sem 4
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Business Law - II</li>
                                  <li>
                                    Technical Accounting & Reporting - III
                                  </li>
                                  <li>Auditing & Attestation - III</li>
                                  <li>Federal Income Taxation - III</li>
                                  <li>Business Law - I</li>
                                  <li>Master Thesis / Project</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>REG 7.3 - 7.7</li>
                                  <li>BAR 6 & 3</li>
                                  <li>AUD 6, 7</li>
                                  <li>REG 4 & 5</li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Section2 */}
          {/* <div className="accordion-item pb-[20px]">
            <div
              className="accordion-header rounded-[14px] ed_program_sha text-white p-4 border-[1px] border-[#3174d6]"
              onClick={() => toggleAccordion(2)}
            >
              <Image
                priority
                src="/images/business/soba/buil.png"
                alt="CFO-readiness"
                className=""
                width={32}
                height={32}
              />
              <h3 className="text-[16px] font-bold leading-[1.3] mt-2">
                MBA - Strategic Finance
                <span
                  className={`float-end text-white ${
                    openAccordion === 2 ? "Active" : "Not-Active"
                  }`}
                ></span>
                {openAccordion === 2 && (
                  <ul className="text-[14px] font-regular mt-2 list-disc list-inside">
                    <li>60 credits</li>
                    <li>Timeline: 2 year program</li>
                    <li>Fees: 1,30,500/-</li>
                    <li>No cost EMI available</li>
                    <li>60% CPA Integrated curriculum</li>
                  </ul>
                )}
              </h3>
            </div>
            {openAccordion === 2 && (
              <div className="accordion-content mt-[4px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)] rounded-b-[14px]">
                <div className="rounded-[14px] bg-[#fff]">
                  <div className="flex justify-between items-center">
                    <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                      <div className="overflow-hidden">
                        <table className="w-full">
                          <thead>
                            <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                              <th className="w-[8%] border-[1px] border-[#1D5287] py-[28px]"></th>

                              <th className="w-[28%] border-[1px] border-[#1D5287] md:text-[24px]">
                                <span>Courses</span>
                              </th>
                              <th className="w-[20%] border-[1px] border-[#1D5287] md:text-[24px]">
                                <span>CPA Integration</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#FFF]">
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black block font-semibold list-disc list-inside">
                                  Sem 1
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Principles of Economics and Markets</li>
                                  <li>Managerial Effectiveness and Ethics</li>
                                  <li>Accounting and Finance</li>
                                  <li>
                                    Organizational Behavior and Human Resources
                                    Management
                                  </li>
                                  <li>Quantitative Techniques and Analytics</li>
                                </ul>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-2 text-[11px] text-black block font-semibold list-disc list-inside">
                                
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black font-semibold list-disc list-inside block">
                                  Sem 2
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Entrepreneurship</li>
                                  <li>Marketing Management and Research</li>
                                  <li>
                                    Banking, Financial Services and Insurance
                                  </li>
                                  <li>Corporate Law</li>
                                  <li>Business Analytics</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                 
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black font-semibold list-disc list-inside block">
                                  Sem 3
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Business Environment and Strategy</li>
                                  <li>Operations Management</li>
                                  <li>
                                    Advanced Financial Accounting & Reporting -
                                    I
                                  </li>
                                  <li>International Auditing - I</li>
                                  <li>International Taxation</li>
                                  <li>Open Elective Course</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 1, 2, 3</li>
                                  <li>AUD 1, 2, 3</li>
                                  <li>REG 1, 2, 3, 4</li>
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black font-semibold list-disc list-inside block">
                                  Sem 4
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Performance Management System</li>
                                  <li>
                                    Advanced Financial Accounting & Reporting -
                                    II
                                  </li>
                                  <li>International Auditing - II</li>
                                  <li>Business Analysis</li>
                                  <li>Cross-Functional Elective Course</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 4, 5, 6, 7</li>
                                  <li>AUD 4, 5, 6, 7</li>
                                  <li>BAR 1, 2, 3</li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div> */}
          {/* Section3 */}
          <div className="accordion-item pb-[20px] ">
            <div
              className="accordion-header rounded-[14px] ed_program_sha text-white p-4 border-[1px] border-[#3174d6]"
              onClick={() => toggleAccordion(3)}
            >
              <Image
                priority
                src="/images/business/soba/web.png"
                alt="CFO-readiness"
                className=""
                width={32}
                height={32}
              />
              <h3 className="text-[16px] font-bold leading-[1.3] mt-2">
                PGD - Accounting and Finance
                <span
                  className={`float-end text-white ${
                    openAccordion === 3 ? "Active" : "Not-Active"
                  }`}
                ></span>
                {/* Show the ul items only when the accordion is active */}
                {openAccordion === 3 && (
                  <ul className="text-[14px] font-regular mt-2 list-disc list-inside">
                    <li>30 credits</li>
                    <li>Timeline: 2 year program</li>
                    <li>Fees: 30,500/-</li>
                    <li>No cost EMI available</li>
                    <li>100% CPA Integrated curriculum</li>
                  </ul>
                )}
              </h3>
            </div>
            {openAccordion === 3 && (
              <div className="accordion-content mt-[4px] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)] rounded-b-[14px]">
                <div className="rounded-[14px] bg-[#fff]">
                  <div className="flex justify-between items-center">
                    <div className="border-[#1D5287] border-[1px] md:w-[106%] w-full mx-auto rounded-[8px] overflow-hidden">
                      <div className="overflow-hidden">
                        <table className="w-full">
                          <thead>
                            <tr className="border-b border-[#3174d6] bg-[linear-gradient(90deg,#0c1f33_0%,#09284a_55%,#0448aa_99.5%)] w-full text-white font-semibold ">
                              <th className="w-[6%] border-[1px] border-[#1D5287] py-[28px]"></th>

                              <th className="w-[28%] border-[1px] border-[#1D5287] md:text-[24px]">
                                <span>Courses</span>
                              </th>
                              <th className="w-[20%] border-[1px] border-[#1D5287] md:text-[24px]">
                                <span>CPA Integration</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#FFF]">
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black block font-semibold list-disc list-inside">
                                  Sem 1
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Financial Accounting & Reporting</li>
                                  <li>Technical Accounting & Reporting - I</li>
                                  <li>Management Accounting - I</li>
                                  <li>Business Finance - I</li>
                                  <li>Business Economics - I</li>
                                </ul>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-2 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 1</li>
                                  <li>FAR 3</li>
                                  <li>FAR 2 & 6.2</li>
                                  <li>FAR 4</li>
                                  <li>BAR 4.3</li>
                                </ul>
                              </td>
                            </tr>
                            <tr className="">
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <span className="py-3 md:px-8 px-2 text-[12px] text-black font-semibold list-disc list-inside block">
                                  Sem 2
                                </span>
                              </td>

                              <td className="border-[1px] font-semibold border-[#1D5287] text-left">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>Business Finance - II</li>
                                  <li>
                                    Not-for-Profit & Governmental Accounting
                                  </li>
                                  <li>Auditing & Attestation - I</li>
                                  <li>Business Economics - II</li>
                                  <li>Business Law - I</li>
                                  <li>Federal Income Taxation - I</li>
                                </ul>
                              </td>
                              <td className="border-[1px] font-semibold border-[#1D5287]">
                                <ul className="py-3 md:px-8 px-5 text-[11px] text-black block font-semibold list-disc list-inside">
                                  <li>FAR 5 & 6.1</li>
                                  <li>FAR 6.5 & 7</li>
                                  <li>AUD 1, 2, 3</li>
                                  <li>BAR 4.4, BAR 4.5</li>
                                  <li>REG 7.1, 7.2</li>
                                  <li>REG 1</li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobBridgeTable;
